import { Avatar, Tooltip, useTheme } from "@mui/material";

import { scopeThreeSpendBasedCategories } from "../../../helpers/components/scopeThreeCategories";

const ScopeThreeCategoryAvatar = ({ scopeThreeCategory, size }) => {
  const { palette } = useTheme();

  const sizePx = size === "small" ? "30px" : "40px";

  const {
    icon,
    subcategory = "spend-based",
    label,
  } = scopeThreeSpendBasedCategories.find(
    (category) => category.scopeThreeCategory === scopeThreeCategory
  ) || {};

  return (
    <Tooltip title={label}>
      <Avatar
        style={{
          backgroundColor: palette[subcategory]
            ? palette[subcategory].main
            : palette?.backgroundGray?.main || "#eee",
          height: sizePx,
          width: sizePx,
        }}
        size={size}
      >
        {icon}
      </Avatar>
    </Tooltip>
  );
};
export default ScopeThreeCategoryAvatar;
